import config from "./app-config.json"
const URL_PROD_V2 = "https://autohelp-v2.escapegameover.com/api"
// const URL_PROD_V2 = "http://escape-public-autohelp-api.test:8080/api"

const {
    build: { mode, type },
    location,
} = config;
let URL;
let LOCATION;

const urlConstructor = () => {
    if (mode === "WEB") {
        return URL = URL_PROD_V2 || process.env.REACT_APP_URL_LEADERBOARD_SYSTEM;
    }
    if (mode === "APP") {
        //  If not set raise warning
        if (!window.ENV) {
            console.warn('Warning URL Vars not detected')
            URL = URL_PROD_V2  || process.env.REACT_APP_URL_LEADERBOARD_SYSTEM;
            console.log({URL})
        };
        URL = window.ENV.URL_LEADERBOARD_SYSTEM|| URL_PROD_V2;
        return URL
    }

}

const locationConstructor = () => {
    if (mode === "WEB") {
        return LOCATION = location;
    }
    if (mode === "APP") {
        if (!window.ENV) {
            LOCATION = location || process.env.REACT_APP_LOCATION ;
            console.warn('Warning Location Environment Vars not detected')
            console.log({LOCATION})
            return LOCATION
        };
        LOCATION =  window.ENV.LOCATION || location;
        return LOCATION
    }
}
const isWeb = () => mode === "WEB"
const isGeneralLeaderboard = () => location === "general"

const getOnlineConfig = async () => {
    const res = await fetch(`${URL_PROD_V2}/leaderboard/config.php${isGeneralLeaderboard() ? "" : `?location=${locationConstructor()}`}`, { method: "GET" })

     return (await res.json())
}
const constructors = {
    urlConstructor,
    locationConstructor,
    isWeb,
    isGeneralLeaderboard,
    getOnlineConfig
}
export default constructors